import { createSlice } from "@reduxjs/toolkit";

export const pezodeUnitListSlice = createSlice({
  name: "pezodeUnitListSlice",
  initialState: {
    pezodeUnitList: [],
  },
  reducers: {
    setPezodeUnitList: (currentSlice, action) => {
      currentSlice.pezodeUnitList = action.payload;
    },
  },
});

export const { setPezodeUnitList } = pezodeUnitListSlice.actions;
export const pezodeUnitListReducer = pezodeUnitListSlice.reducer;
